import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean };

export class PluginErrorBoundary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: any) {
		console.error('Plugin render error', error);
	}

	render() {
		if (this.state.hasError) {
			return <div className="glass-card p-4" role="alert">Plugin failed to render.</div>;
		}
		return this.props.children;
	}
}


